import type { SearchResponse, SearchResult } from '@munifocus/contracts-web';
import { api } from './api-client';

/**
 * Global search behind the command palette. Uses the anonymous client — this
 * endpoint only ever serves published, public content.
 *
 * Takes the palette's `AbortSignal` so a superseded keystroke's request is
 * cancelled in flight rather than raced to completion.
 */
export async function globalSearch(
  query: string,
  lang: 'en' | 'fr',
  signal: AbortSignal,
): Promise<SearchResult[]> {
  const { data } = await api.get<SearchResponse>('/search', {
    params: { q: query, lang },
    signal,
  });
  return data.results;
}
